var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload"},[_c('a-upload',{attrs:{"file-list":_vm.fileList,"custom-request":_vm.customRequest},on:{"change":_vm.handleChange}},[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" 选择文件上传 ")],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }